/*
 * One rAF-throttled passive scroll/resize listener for the whole page, shared
 * by every parallax layer and by the path timeline. Subscribers get called with
 * the current viewport height; they read their own geometry from there.
 */
const subscribers = new Set();
let frame = 0;
let listening = false;

function run() {
  frame = 0;
  const viewportHeight = window.innerHeight;
  for (const fn of subscribers) fn(viewportHeight);
}

function schedule() {
  if (!frame) frame = requestAnimationFrame(run);
}

export function onScroll(fn) {
  subscribers.add(fn);

  if (!listening) {
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    listening = true;
  }

  fn(window.innerHeight);

  return () => {
    subscribers.delete(fn);
    if (subscribers.size === 0 && listening) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      listening = false;
      if (frame) {
        cancelAnimationFrame(frame);
        frame = 0;
      }
    }
  };
}
